module.exports = __webpack_public_path__ + "img/119-brunei.c9854b6a.svg";